import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Klasifikasi Akun',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Klasifikasi Akun',
        href: '/adm/fin/master/klasifikasi-akun',
        active: true,
      },
    ],
    loading: false,
    form: {
      acc_name: '',
      acc_alias: '',
      acc_cash_flow: 1,
    },
    form_level_two: {
      acc_name: '',
      first_id: '',
      last_id: '',
    },
    choose_account: '',
    acc_level_one: [],
    acc_level_two: [],
    acc_level_three: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_level_two(state) {
    return state.data.form_level_two;
  },
};

export const mutations = {
  changeKlasifikasiAkun(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getAccountLevelOne({ commit }) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/account/level-one`);
    let data_acc = !result.error ? result.data.object : [];
    if (data_acc && data_acc.length > 0) {
      data_acc[0].active = true;
    }

    commit('changeKlasifikasiAkun', {
      acc_level_one: data_acc,
      choose_account:
        data_acc && data_acc.length > 0 ? data_acc[0].id_account : '',
      loading: false,
    });

    return data_acc;
  },

  async getAccountLevelTwo({ commit }, payload = null) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/account/level-two`, {
      id_parent: payload ? payload.id : null,
    });

    let data_acc = !result.error ? result.data.object : [];
    commit('changeKlasifikasiAkun', {
      acc_level_two: data_acc,
      loading: false,
    });

    return data_acc;
  },

  async getAccountLevelThree({ commit }, payload = null) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/account/level-three`, {
      id_parent: payload ? payload.id : null,
    });

    let data_acc = !result.error ? result.data.object : [];

    commit('changeKlasifikasiAkun', {
      acc_level_three: data_acc,
      loading: false,
    });

    return data_acc;
  },

  async createAccountLevelTwo({ commit, state, dispatch }) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    const { data } = state;
    data.form_level_two.id_parent = data.choose_account;
    let result = await ApiPostRequest(
      `fin/account/level-two`,
      data.form_level_two
    );
    commit('changeKlasifikasiAkun', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async updateAccountLevelTwo({ commit, state, dispatch }, payload = null) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `fin/account/level-two/${payload.id}`,
      data.form_level_two
    );
    commit('changeKlasifikasiAkun', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteAccountLevelTwo({ commit, state, dispatch }, payload = null) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiDeleteRequest(
      `fin/account/level-two/${payload.id}`,
      data.form
    );
    commit('changeKlasifikasiAkun', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async createAccountLevelThree({ commit, state, dispatch }) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    const { data } = state;
    data.form.id_parent = data.choose_account;
    let result = await ApiPostRequest(`fin/account/level-three`, data.form);
    commit('changeKlasifikasiAkun', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async updateAccountLevelThree({ commit, state, dispatch }, payload = null) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `fin/account/level-three/${payload.id}`,
      data.form
    );
    commit('changeKlasifikasiAkun', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteAccountLevelThree({ commit, state, dispatch }, payload = null) {
    commit('changeKlasifikasiAkun', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiDeleteRequest(
      `fin/account/level-three/${payload.id}`,
      data.form
    );
    commit('changeKlasifikasiAkun', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
